import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TimeTableModel } from 'src/app/models/TimeTableModel';
import { httpOptions } from 'src/app/global/global_variables';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { ExpeditionResponse } from 'src/app/models/ExpeditionResponse';
import { environment } from 'src/environments/environment';
import { TripResponse, TripsAPIResponse } from 'src/app/models/TripResponse';

@Injectable({
  providedIn: 'root'
})
export class ExpeditionService {
  apiLink = environment.apiLink;
  httpOptions = httpOptions;
  public dockId: number = 0;

  constructor(private http: HttpClient) { }

  getTimeTableData(): Observable<TimeTableModel[]> {
    return this.http.get<TimeTableModel[]>(`${this.apiLink}/TimeTable/GetTimeTable`, httpOptions)
  }

  getTimeTableDataView(): Observable<TimeTableModel[]> {
    return this.http.get<TimeTableModel[]>(`${this.apiLink}/View/GetTimeTable`, httpOptions)
  }

  getExpeditionTableData(): Observable<ExpeditionResponse> {
    return this.http.get<ExpeditionResponse>(`${this.apiLink}/Line/GetExp`, httpOptions)
  }
  
  getExpeditionTableDataView(): Observable<ExpeditionResponse> {
    return this.http.get<ExpeditionResponse>(`${this.apiLink}/View/GetExp`, httpOptions)
  }

  getActiveTrip(dockId: number): Observable<TripsAPIResponse> {
    const url = `${this.apiLink}/View/GetTrips?dockId=${dockId}`;

    return this.http.get<TripsAPIResponse>(url, this.httpOptions).pipe(
      map(response => ({
        tripsInQueue: response.tripsInQueue
          .filter((trip: TripResponse) => trip.status === 1)
      })),
      catchError(error => {
        console.error('Erro ao buscar a viagem ativa:', error);
        return of({ tripsInQueue: [] });
      })
    );
  }

  getNextTripInQueue(dockId: number): Observable<TripsAPIResponse> {
    const url = `${this.apiLink}/View/GetTrips?dockId=${dockId}`;

    return this.http.get<TripsAPIResponse>(url, this.httpOptions).pipe(
      map(response => ({
        tripsInQueue: response.tripsInQueue
          .filter((trip: TripResponse) => trip.status === 0)
          .sort((a: any, b: any) => a.queueOrder - b.queueOrder)
      })),
      catchError(error => {
        console.error('Erro ao buscar a próxima viagem na fila:', error);
        return of({ tripsInQueue: [] });
      })
    );
  }

  updateTripsStatus(tripNumber: number, status: number): Observable<void> {
    const url = `${this.apiLink}/View/UpdateStatus/${tripNumber}/${status}`;

    return this.http.put<void>(url, {}, this.httpOptions)
      .pipe(
        tap(() => this.getActiveTrip(this.dockId)),
        catchError(error => {
          console.error(`Erro ao atualizar o status da viagem ${tripNumber}: `, error);
          return throwError(() => new Error('Erro ao atualizar o status da viagem'))
        })
      )
  }

  saveOnExpeditionTrucksDatabase(dockId: number, tripNumber: number): Observable<void> {
    const url = `${this.apiLink}/View/UpdateExp`;
    const body = { dockId, tripNumber };

    return this.http.put<void>(url, body, this.httpOptions).
      pipe(
        catchError(error => {
          console.error(`Erro ao salvar dados para viagem ${tripNumber}: `, error)
          return throwError(() => new Error('Erro ao salvar dados'))
        })
      )
  }

}
